import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const SiteMetadataContext = createContext(null);
const SiteMetadataProvider = ({ children, ...value }) => {
  return /* @__PURE__ */ jsx(SiteMetadataContext.Provider, { value, children });
};
function useSiteMetadataContext() {
  const context = useContext(SiteMetadataContext);
  if (!context) {
    throw new Error("useSiteMetadataContext must be used within SiteMetadataProvider");
  }
  return context;
}
export {
  SiteMetadataProvider as S,
  useSiteMetadataContext as u
};
